module.exports = __webpack_public_path__ + "assets/img/r2.06727036.png";